import { getChestcontentSize } from '~/components/Chest/helpers'

import ChecklistRewardAnimationXp from './ChecklistRewardAnimationXP'

export default function ChecklistChestReward({
  isDesktop,
  xp,
}: {
  isDesktop: boolean
  xp: number
}): React.ReactElement {
  const scaleSize = isDesktop ? getChestcontentSize('medium') : getChestcontentSize('small')
  return (
    <div className={`relative z-10 ${scaleSize ? scaleSize : ''}`}>
      {xp > 0 && <ChecklistRewardAnimationXp noOfXPs={xp} />}
    </div>
  )
}
